<template>
  <aha-modal
    :title="title_PresentationBeingEdited"
    @hide="$emit('cancel')"
    :closable="false"
    :noCloseOnBackdrop="true"
    :noCloseOnEsc="true"
  >
    <p>{{ $i18nPresenter.t('Reload to continue presenting.') }}</p>
    <template #action>
      <aha-button
        variant="primary"
        @click="onClickReload"
        :submitting="isReloading"
        :disabled="isReloading"
      >
        {{ $i18nPresenter.t('Reload') }}
      </aha-button>
    </template>
  </aha-modal>
</template>

<script>
export default {
  name: 'MSTeamsReloadModal',
  props: {
    isReloading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title_PresentationBeingEdited: 'Presentation being edited on AhaSlides',
    }
  },
  methods: {
    onClickReload() {
      this.$emit('ok')
    },
  },
}
</script>
